<template>
  <div class="viewurl-page-table">   
    <div class="page-product-table-box">
      <div class="page-header">
          <h2>{{$t('dsfx.t13')}}</h2>
      </div>
      <div class="searchwrap">
        <div class="pricetablesearchline">
          <el-input 
            style="width:250px" 
            v-model="query.search" 
            :placeholder="$t('jgjk.s265')" 
            size="mini" 
            @keyup.enter.native="onTableListSaerch()"
          ></el-input>
          <el-button type="danger" @click="onTableListSaerch()" size="mini">{{ $t('dsfx.t26') }}</el-button>
        </div>
      </div>
    </div>
    
    <div class="tablebox">
      <el-table
        :data="tableData"
        :cell-style="this.getTableCellStyle"
        v-loading="tableloading" 
        tooltip-effect="dark" 
        style="width: 100%"
        @sort-change="sortthiscolumn"
      >
        <el-table-column prop='AssetId' label="ASSETID" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">
              {{ scope.row.ProductName }}
            </a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('activebrand.t50')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t9')" width="140">
          <template slot-scope="scope">
            <i v-if="scope.row.Daigou > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xfsp.sales')" prop='HighSales' width="80" sortable='custom'>
          <template slot-scope="scope">
            <i v-if="scope.row.HighSales > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t10')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.ImgCheck > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t11')" prop='LowPrice' width="110" sortable='custom'>
          <template slot-scope="scope">
            <i v-if="scope.row.LowPrice > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('xfsp.keywords')" width="80">
          <template slot-scope="scope">
            <i v-if="scope.row.KeyWords > 0" class="el-icon-success tableicontypes"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t12')" prop='TotalScore' width="80">
          <template slot-scope="scope">
            {{scope.row.TotalScore}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('Infringements.t14')" prop="Qqfenlei" show-overflow-tooltip width="110" sortable='custom'>
          <template slot-scope="scope">
            {{scope.row.Qqfenlei}}
          </template>
        </el-table-column>
        <el-table-column prop="Suggestion" :label="$t('Infringements.t13')" show-overflow-tooltip width="120" sortable='custom'>
          <template slot-scope="scope">
            {{scope.row.Suggestion}}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="query.size"
        layout="total, prev, pager, next, sizes"
        :total="pagingtotal">
      </el-pagination>      
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      searchNeedle: '',
      query: {
        skuid: this.$route.params.SkuId,
        page: 1,
        size: 25,
        search: '',
        order: '01',
        taskid: ''
      },
      tableloading: false,
      tableData: [],
      pagingtotal: 0,
      currentPage: 1,
      multipleSelection: [],
      ischeckeditems: false,
      downloadarr: ''
    }
  },

  mounted(){
    let skuinfo = JSON.parse(localStorage.getItem("ecommercedefenseviewurl")).val
    this.query.taskid = skuinfo.taskid
    this.getPagelist()
  },

  methods: {

    /**
     * 搜索
     */
    onTableListSaerch: function(){
      this.getPagelist()
    },

    /**
     * handleSizeChange
     */
    handleSizeChange: function(val){
      this.currentPage = 1
      this.query.page = 1
      this.query.size = val
      this.getPagelist()
    },

    /**
     * handleCurrentChange
     */
    handleCurrentChange: function(val){
      this.query.page = val
      this.getPagelist()
    },

    /**
     * Paging
     */
    getPagelist: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/detail/paging'
      let data = that.query
      that.tableloading = true
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getPagelist', rex)
          let tablelists = rex.results[1]
          tablelists.forEach( item => {
            item.TotalScore = that.setLevels(item.TotalScore)
            item.Qqfenlei = that.setInfringementsType(item.Qqfenlei).txt
            item.Suggestion = that.setInfringementsSuggestion(item.Suggestion).txt
          })
          that.tableData = tablelists
          that.pagingtotal = rex.results[0][0].Count
          that.tableloading = false
        },
        error: function(response) {
          console.log('getPagelist', response)
        }
      })      
    },

    /**
     * 已下载的数据不能下载
     */
    selectable(row) {
      if(row.downStatus === null || row.downStatus/1 === 0){
        return true
      }else{
        return false
      }      
    },

    /**
     * 下载数据
     */
    downloaddata: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/detail/paging?'
                + 'skuid=' + that.query.skuid + '&'
                // + 'page=' + that.query.page + '&'
                // + 'size=' + that.query.size + '&'
                + 'search=' + that.query.search + '&'
                + 'assetidArr=' + that.downloadarr + '&'
                + 'downfile=1'
      let setdate = new Date()
      let filename = setdate.getTime()
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send()      
    },

    /**
     * 列表排序
     */
    sortthiscolumn: function(column){
      console.log(column)
      if(column.prop == "HighSales" && column.order == "ascending"){
        this.query.order = '00'
        this.getPagelist()
      }else if(column.prop == "HighSales" && column.order == "descending"){
        this.query.order = '01'
        this.getPagelist()
      }else if(column.prop == "HighSales" && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == "ascending"){
        this.query.order = '10'
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == "descending"){
        this.query.order = '11'
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == "ascending"){
        this.query.order = '20'
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == "descending"){
        this.query.order = '21'
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == "ascending"){
        this.query.order = '30'
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == "descending"){
        this.query.order = '31'
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == "ascending"){
        this.query.order = '40'
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == "descending"){
        this.query.order = '41'
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == null){
        this.query.order = ''
        this.getPagelist()
      }else{
        return
      }
    },

  }
}
</script>